import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CCReportGroupedViewBarChart, { GroupedBarChartData } from './CCReportGroupedViewBarChart';
import { Box } from 'components/index';

interface DetailedChartViewDialogProps {
  title: string;
  open: boolean;
  onClose: () => void;
  groupedData: GroupedBarChartData[];
}

const DetailedChartViewDialog: React.FC<DetailedChartViewDialogProps> = ({ title, open, onClose, groupedData }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='lg' fullWidth>
      <DialogTitle>
        {`Detailed View - ${title}`}
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {/* Wrap the chart inside a Box and center align */}
        <Box width='100%' display='flex' justifyContent='center'>
          <CCReportGroupedViewBarChart data={groupedData} />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DetailedChartViewDialog;
